<template>
  <div class="mt-md-3 mt-1">
    <div class="sub-title">{{ panelCount }} panelen</div>

    <div class="card card-panels card-body">
      <div class="row">
        <div class="col-md-13 material-price grayed-price">
          Prijs panelen
          <div class="price-value">
            {{ orderDetails.price | price }}
          </div>
        </div>
        <div class="col-md-13 transport-price grayed-price">
          Transportkosten
          <div class="price-value">
            {{ orderDetails.deliveryPrice | price }}
          </div>
        </div>

        <div class="col-md-13 total-price mt-3">
          Totaalprijs (ex. BTW)
          <div class="price-value">
            {{ totalPrice | price }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    data() {
      return {}
    },
    computed: {
      totalPrice() {
        return this.orderDetails.price + this.orderDetails.deliveryPrice
      },
      panelCount() {
        return this.orderDetails.cart.reduce((total, material) => {
          return total + material.panels.length
        }, 0)
      },
      orderDetails() {
        return this.$store.getters.orderDetails
      }
    }
  }
</script>

<style lang="scss" scoped>
  .sub-title {
    margin-bottom: 5px;
    font-size: 1.2em;
  }

  .price-value {
    font-size: 1.1em;
    font-weight: bold;
  }

  .card-panels {
    padding-bottom: 5px;
  }
</style>
